import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteContentDocument } from './delete.generated';

export const useDeleteContent = (options: ApiOptions<typeof DeleteContentDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteContentDocument, {
    ...useNotifications(DeleteContentDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.content.delete_success'),
    }),
    update(cache, { data }) {
      if (!data?.deleteContent?.deletedItems.length) return;
      data.deleteContent.deletedItems.forEach(({ id, __typename }) =>
        cache.evict({ id: cache.identify({ id, __typename }) }),
      );
    },
    ...options,
  });
};
